/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import {
  EXPORTING_RATINGS_ANALYTICS
} from 'state/actions/ratingsState/analyticsStatus';


/* ========== ~~~~~~~~~~  ANALYTICS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
  isExporting: null
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
const analyticsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
      case EXPORTING_RATINGS_ANALYTICS:
        newState.isExporting = action.status ? action.format : null;
        return newState;
      default:
        return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default analyticsStatus;
